import { useState } from "react";
import { Alert, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { UnauthorizedError } from "../../errors/http_errors";
import { User } from "../../models/user";
import * as UserApi from "../../network/user_api";
import { LoginCredentials } from "../../network/user_api";
import styles from "./Modal.module.scss";
import TextInputField from "../FormFields/TextInputField";
import ActionButton from "../Buttons/Action/ActionButton";
import Divider from "../Decors/Divider/Divider";
import CloseButton from "../Buttons/Close/CloseButton";

interface LoginModalProps {
  onDismiss: () => void;
  onLoginSuccessful: (user: User) => void;
}

const LoginModal = ({ onDismiss, onLoginSuccessful }: LoginModalProps) => {
  const [errorText, setErrorText] = useState<string | null>(null);
  const { t } = useTranslation();

  // @ts-ignore
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<LoginCredentials>();

  async function onSubmit(credentials: LoginCredentials) {
    try {
      const user = await UserApi.login(credentials);
      onLoginSuccessful(user);
    } catch (error) {
      if (error instanceof UnauthorizedError) {
        setErrorText(error.message);
      } else {
        alert(error);
      }
      console.error(error);
    }
  }

  return (
    <Modal dialogClassName={styles.modalWindow} show onHide={onDismiss}>
      <Modal.Header className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>
          {t("common.login")}
        </Modal.Title>
        <CloseButton onDismiss={onDismiss} />
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <div className={styles.smallDivider}>
          <Divider />
        </div>
        {errorText && <Alert variant="danger">{errorText}</Alert>}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <TextInputField
            name="userName"
            label={t("common.username")}
            type="text"
            placeholder="janedoe"
            register={register}
            registerOptions={{ required: "Required" }}
            error={errors.userName}
          />
          <TextInputField
            name="password"
            label={t("common.password")}
            type="password"
            placeholder="Password"
            register={register}
            registerOptions={{ required: "Required" }}
            error={errors.password}
          />
          <div className={styles.modalButtonContainer}>
            <ActionButton
              className={`${styles.modalButton}`}
              type="submit"
              disabled={isSubmitting}
            >
              {t("common.login")}
            </ActionButton>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer className={styles.modalBody} />
    </Modal>
  );
};

export default LoginModal;
